export const isBrowser = () => {
    if (global && global.SSR) return true;
    return typeof window !== 'undefined';
};